var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfoGeneral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "24px",
    viewBox: "0 0 8 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "---",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "014-Profile",
    transform: "translate(-949.000000, -225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "general-info",
    transform: "translate(901.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(20.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-6-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 3.15,
    strokeLinecap: "round",
    points: "3.56751505 21.6340412 2.07231985 21.6340412 2.07231985 8.14857261 0.321125 8.14857261"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.16751505,
    y1: 21.6340412,
    x2: 0.67231985,
    y2: 21.6340412,
    id: "Path-6-Copy-4",
    stroke: "#FFFFFF",
    strokeWidth: 3.15,
    strokeLinecap: "round",
    transform: "translate(1.419917, 21.634041) scale(-1, 1) translate(-1.419917, -21.634041) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 2.1,
    cy: 2.1,
    r: 2.1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoGeneral);
export default __webpack_public_path__ + "static/media/icon-info-general.e84a9bf66b88529da71b7cc358ec79ab.svg";
export { ForwardRef as ReactComponent };